import { useAuth } from '@web/walter-lib/auth'
import { useUserAuth } from '~api'

let isLogoutLoading = false

export const useIsAuth = () => {
    const { logout } = useAuth()
    const { error, isLoading } = useUserAuth()

    if (!isLoading && (error?.response?.status === 401 || error?.response?.status === 403)) {
        if (!isLogoutLoading) {
            isLogoutLoading = true
            logout(true)
        }
    }
}
